import React, { useState, useEffect, useRef } from 'react'
import { ArticleArea } from '../../../Styling/Layout/ContentArea'
import { PbiReportContainer } from '../../pbiReport/PbiReportContainer'
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import PbiSvgLogo from '../../../assets/pbiicon.svg'
import colorConfig from '../../../colorConfig';
import { usePbiReportListTab } from './usePbiReportListTab'
import CaseListToolTip from '../../caselist_redux/caseListTable/CaseListTooltip';

const PbiLogo = () => {
    return (
        <img style={{marginTop: "-2px"}} src={PbiSvgLogo} alt='logo' height='25px' />
    )
}

const ReportButtons = styled.div`
    text-align: left; 
    margin: 15px auto; 
    clear: both;   
    display: flex; 
    flex-direction: column;
    gap: 10px;
`;

const ReportButton = styled.button`
    width: 200px; 
    height: 55px;
    margin-right: 20px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    border: none;
    border-radius: 0.5em;
    font-family: "RM Neue", "sans-serif";
    font-size: 16px;
    color: black;
    background-color: ${({ isActive }) =>
        isActive ? colorConfig.button_bg : colorConfig.krem};
    cursor: pointer;

    :focus {
        background-color: ${colorConfig.button_focused};
        color: black !important;     
    }
`;

const PbiArea = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;

const LeftMenuButtons = styled.div`
  height: ${({ dynamicHeight }) => `${dynamicHeight}px`};
  width: ${({ isExpanded }) => (isExpanded ? "250px" : "0px")};
  padding-right: ${({ isExpanded }) => (isExpanded ? "40px" : "0px")};
  overflow: hidden;
  transition: width 0.3s ease-in-out, padding-right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: ${({ isExpanded }) => (isExpanded ? "flex-start" : "flex-end")};
`;

const ToggleButton = styled.div`
  position: absolute;
  left: ${({ isExpanded }) => (isExpanded ? "220px" : "10px")};
  transform: translateY(-50%);
  top: 30px;
  cursor: pointer;
  font-size: 20px;
  transition: left 0.3s ease-in-out;
  color: #333;
  display: flex;

  &:hover {
    color: #0078D4;
  }
`;

const ReportArea = styled.div`
  flex: 1;
  padding-left: 20px;
  transition: padding-left 0.3s ease-in-out;
`;

const PlaceholderText = styled.div`
    text-align: center;
    line-height: 700px;
    font-size: 20px;
    color: black;
`;

export const ReportNavLink = styled(NavLink)`
    all: unset;
    text-decoration: none;    
    background-color: 'transparent';

    :hover {
        text-decoration: underline;  
        color: white !important;    
        -webkit-transition: background-color 1.5s ease-out;
        -moz-transition: background-color 1.5s ease-out;
        -o-transition: background-color 1.5s ease-out;
        transition: background-color 1.5s ease-out;
        transition-delay:0.1s;  
    }
`

export const PbiReportListTab = (props) => {

    const { reportMenuState, groupedReports, groupNames, showTheSpinner, localeMessages } = usePbiReportListTab(props)

    const [selectedReportId, setSelectedReportId] = useState('');
    const [isExpanded, setIsExpanded] = useState(true);
    const [dynamicHeight, setDynamicHeight] = useState(0);

    // Setter defaultReportId for å vise Dashbord med engang bruker går til Rapporter. 
    useEffect(() => {
        // Dashbord reportId i test = "48";
        // Dashbord reportId i prod = "73";
        if (groupedReports && groupedReports.Dashbord) {
          const newDefault = groupedReports.Dashbord.find(
            report => report.reportGroup === 'Dashbord' // Sjekker heller på reportGroup for å unngå potensiell krøll med IDer
          )?.reportId || '';
          setSelectedReportId(newDefault);
        }
      }, [groupedReports]);

    const handleReportClick = (reportId) => {
        if (reportId !== selectedReportId) {
            setSelectedReportId(reportId);
        }
    };

    const reportButtonsRef = useRef(null);

    useEffect(() => {
        if (reportButtonsRef.current) {
            setDynamicHeight(reportButtonsRef.current.clientHeight);
        }
    }, [groupNames]);

    const printRow = (report, i, handleButtonClick, activeButton) => {
        // const uri = `/Reports/Run/${report.reportId}`
        return (
            <ReportButton
                key={report.reportId}
                onClick={() => handleButtonClick(report.reportId)}
                isActive={activeButton === report.reportId}
            >
                <b  style={{ marginLeft: "10px" }}>{report.reportName}</b>
            </ReportButton>
        );
    }
    
    const ReportListComponent = ({ groupname, reportItems, onReportClick }) => {    
        const [activeButton, setActiveButton] = useState(selectedReportId);
    
        const handleButtonClick = (id) => {
            setActiveButton(id);
            onReportClick(id);
        };
    
        return (
            <div>
                <ReportButtons>
                    <h4 style={{ align: "left" }}>{groupname}</h4>
                    {reportItems.map((row, i) => (
                        <div key={i}>
                            {printRow(row, i, handleButtonClick, activeButton)}
                        </div>
                    ))}
                </ReportButtons>
            </div>
        );
    };

    const pbiReportGroup = (groupname) => {
        return (
            <>
                {groupedReports &&
                    <ReportListComponent
                        reportItems={groupedReports[groupname]}
                        groupname={groupname}
                        onReportClick={handleReportClick}
                    />
                }

            </>
        )
    }

    return (
        <div style={{ paddingTop: "20px", position: "relative" }}>
            <ArticleArea style={{ paddingLeft: "10px" }}>
                <h1>{localeMessages.HEADER_T1}</h1>
                <p>{localeMessages.PARAGRAPH_P1}</p>
            </ArticleArea>
            <PbiArea>
                {/* Left Menu, kan minimeres */}
                <LeftMenuButtons isExpanded={isExpanded} dynamicHeight={dynamicHeight}>
                    <div ref={reportButtonsRef}>
                        {isExpanded &&
                            groupNames?.map((grname, i) => (
                                <div key={i}>{pbiReportGroup(grname)}</div>
                            ))}
                    </div>
                </LeftMenuButtons>
                {/* Knapp for minimering av Left menu. Kun synlig om rapport er valgt.*/}
                {(!showTheSpinner() && selectedReportId) && (<CaseListToolTip caption={isExpanded ? "Skjul meny" : "Vis meny"}>
                    <ToggleButton isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
                        <span className= {isExpanded ? "fa fa-arrow-left" : "fa fa-arrow-right"}></span>
                    </ToggleButton>
                </CaseListToolTip>)}
                {/* Report Content Area */}
                <ReportArea isExpanded={isExpanded}>
                    {selectedReportId ? (
                        <PbiReportContainer reportId={selectedReportId} />
                    ) : (
                        <PlaceholderText style={{alignContent:'center'}}>{localeMessages.PARAGRAPH_P2}</PlaceholderText>
                    )}
                </ReportArea>
            </PbiArea>
        </div>
    );
}
